import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function PortfolioPlLeavesChartHelp() {
    return (
        <IconTooltip>
            <div>
                This chart displays the total value of orders split by side (Buy
                or Sell).
            </div>
        </IconTooltip>
    );
}
